{
    "Absenden": "Отправить",
    "Bitte prüfe den Link oder frag deine Gastgeber nach einem neuen.": "Проверьте ссылку или попросите хозяев прислать новую.",
    "ca. {seconds} Sek.": "ок. {seconds} сек.",
    "Danke für dein Feedback!": "Спасибо за ваш отзыв!",
    "Danke trotzdem, dass du dir Zeit nehmen wolltest!": "Всё равно спасибо, что хотели уделить время!",
    "Danke, dein Feedback ist schon angekommen": "Спасибо, ваш отзыв уже получен",
    "Dein Kommentar (optional)": "Ваш комментарий (необязательно)",
    "Deine Antworten helfen deinen Gastgebern, noch besser zu werden.": "Ваши ответы помогают хозяевам стать ещё лучше.",
    "Deine Antworten helfen {house}, noch besser zu werden.": "Ваши ответы помогают {house} стать ещё лучше.",
    "Deine Antworten sind für den Gastgeber anonym.": "Ваши ответы анонимны для хозяев.",
    "Deine Antworten sind gespeichert und werden gesendet, sobald du wieder online bist.": "Ваши ответы сохранены и будут отправлены, как только вы снова будете онлайн.",
    "Deine Gastgeber haben im Moment keine Umfrage aktiviert. Schau gern später noch einmal vorbei.": "Сейчас у ваших хозяев нет активного опроса. Загляните позже.",
    "Die Umfrage konnte nicht geladen werden. Prüfe deine Internetverbindung.": "Не удалось загрузить опрос. Проверьте подключение к интернету.",
    "Diese Umfrage ist nicht mehr verfügbar": "Этот опрос больше недоступен",
    "Dieser Link ist ungültig": "Эта ссылка недействительна",
    "Erneut versuchen": "Попробовать снова",
    "Fast oben …": "Почти на вершине …",
    "Feedback geben": "Оставить отзыв",
    "Fortschritt": "Прогресс",
    "Geht so": "Так себе",
    "Gerade gibt es keine Umfrage": "Сейчас опроса нет",
    "Gipfelstürmer": "Покоритель вершин",
    "Gut": "Хорошо",
    "Ja": "Да",
    "Ja, etwas schreiben": "Да, написать",
    "Keine Verbindung": "Нет соединения",
    "Mehrfachauswahl möglich": "Можно выбрать несколько",
    "Nein": "Нет",
    "Nein, fertig": "Нет, готово",
    "Nein, weiter": "Нет, дальше",
    "Noch {count} Fragen": {
        "one": "Остался {n} вопрос",
        "few": "Осталось {n} вопроса",
        "many": "Осталось {n} вопросов"
    },
    "Schlecht": "Плохо",
    "Sehr gut": "Очень хорошо",
    "Sehr schlecht": "Очень плохо",
    "sehr wahrscheinlich": "очень вероятно",
    "Umfrage wird geladen …": "Загружаем опрос …",
    "unwahrscheinlich": "маловероятно",
    "Zur Gäste-App": "В приложение для гостей",
    "Zurück zur App": "Назад в приложение",
    "{value} von 5": "{value} из 5",
    "„{name}“ und alle Einträge darin werden entfernt. Das lässt sich nicht rückgängig machen.": "«{name}» и все записи в нём будут удалены. Отменить это нельзя.",
    "{count} Adressen in der Nähe": {
        "one": "{n} адрес поблизости",
        "few": "{n} адреса поблизости",
        "many": "{n} адресов поблизости"
    },
    "{count} Einträge liegen außerhalb des neuen Zeitraums und sind jetzt wieder ohne Tag.": {
        "one": "{n} запись выходит за новые даты и теперь без дня.",
        "few": "{n} записи выходят за новые даты и теперь без дня.",
        "many": "{n} записей выходят за новые даты и теперь без дня."
    },
    "{count} Nächte": {
        "one": "{n} ночь",
        "few": "{n} ночи",
        "many": "{n} ночей"
    },
    "{count} Orte in der Nähe": {
        "one": "{n} место поблизости",
        "few": "{n} места поблизости",
        "many": "{n} мест поблизости"
    },
    "{count} Tipps deiner Gastgeber": {
        "one": "{n} совет ваших хозяев",
        "few": "{n} совета ваших хозяев",
        "many": "{n} советов ваших хозяев"
    },
    "{count} Touren in der Nähe": {
        "one": "{n} маршрут поблизости",
        "few": "{n} маршрута поблизости",
        "many": "{n} маршрутов поблизости"
    },
    "{count}-Tage-Vorhersage": "Прогноз на {count} дней",
    "{day} · {time} Uhr": "{day} · {time}",
    "{day} · ganztägig": "{day} · весь день",
    "{day}. {mon} · {time} Uhr": "{day} {mon} · {time}",
    "{feature} gehört zu dir, nicht zum Haus — deine Auswahl und deine Nachrichten bleiben erhalten, wenn du ein Konto anlegst. Alles andere in der App kannst du weiterhin ohne Konto nutzen.": "{feature} принадлежит вам, а не дому: ваш выбор и ваши сообщения сохранятся, если вы создадите аккаунт. Всем остальным в приложении можно пользоваться и без него.",
    "{feature} ist bald verfügbar.": "{feature} — скоро.",
    "{feature} steht dir zur Verfügung, sobald deine E-Mail-Adresse bestätigt ist. Öffne dazu den Link, den wir dir geschickt haben.": "{feature} станет доступно, как только вы подтвердите адрес электронной почты. Откройте ссылку, которую мы вам отправили.",
    "{from}–{to} Uhr": "{from}–{to}",
    "{label} & Gewitter": "{label} и гроза",
    "{list} & mehr": "{list} и другое",
    "{n} hm Aufstieg": "{n} м набора высоты",
    "{n} km": "{n} км",
    "{n} m": "{n} м",
    "{speed} aus {compass}": "{speed} с {compass}",
    "{time} Uhr": "{time}",
    "{title} zum Planer hinzufügen": "Добавить «{title}» в планер",
    "10 – 21 Uhr": "10:00 – 21:00",
    "25 Min": "25 мин",
    "50 Min": "50 мин",
    "60 Min": "60 мин",
    "7 Tage": "7 дней",
    "7 Tage & Details": "7 дней и детали",
    "80 Min": "80 мин",
    "Ab {age} Jahren": "От {age} лет",
    "ab {amount}": "от {amount}",
    "ab {from} Uhr": "с {from}",
    "Abbrechen": "Отмена",
    "abgesagt": "отменено",
    "Abmelden": "Выйти",
    "Abreise": "Отъезд",
    "AGB": "Условия",
    "Aktualisiert {time} Uhr": "Обновлено в {time}",
    "Aktuell nichts geplant": "Пока ничего не запланировано",
    "Alle": "Все",
    "Alle ausklappen": "Развернуть все",
    "Alle einklappen": "Свернуть все",
    "Alle Empfehlungen": "Все рекомендации",
    "Alle Events": "Все события",
    "Alles eingeplant. Neue Favoriten landen hier.": "Всё распределено. Новое избранное появится здесь.",
    "Alles klar": "Понятно",
    "Alles zeigen": "Показать всё",
    "Als Gast angemeldet": "Вы вошли как гость",
    "Als Gast fortfahren": "Продолжить как гость",
    "Als Nächstes": "Далее",
    "Am Haus": "У дома",
    "Änderungen speichern": "Сохранить изменения",
    "Anmelden": "Войти",
    "Anmeldung erforderlich": "Требуется регистрация",
    "Anmeldung fehlgeschlagen. Du kannst auch als Gast fortfahren.": "Не удалось войти. Вы можете продолжить как гость.",
    "Anreise": "Заезд",
    "Ansehen": "Смотреть",
    "Architektur": "Архитектура",
    "Auf die Tage verteilen": "Распределить по дням",
    "Aufenthalt": "Пребывание",
    "Aufguss-Zeremonie": "Церемония ароматического пара",
    "Aus dem Planer entfernt.": "Удалено из планера.",
    "Aussichtspunkt": "Смотровая площадка",
    "ausverkauft": "распродано",
    "Ausverkauft": "Распродано",
    "Bäckerei": "Пекарня",
    "Bad & Badestelle": "Бассейн и место для купания",
    "Bar": "Бар",
    "Barrierefrei zugänglich": "Доступно без ступеней",
    "Behandlungen": "Процедуры",
    "Berghütte": "Горная хижина",
    "bestätigt": "подтверждён",
    "Bewölkt": "Облачно",
    "Bewölkung": "Облачность",
    "Biergarten": "Пивной сад",
    "Bild {i} von {total} vergrößern": "Увеличить изображение {i} из {total}",
    "Bild vergrößern": "Увеличить изображение",
    "Bilder": "Фотографии",
    "Bitte bestätige deine E-Mail": "Подтвердите адрес электронной почты",
    "Bitte gib dein Passwort ein.": "Введите пароль.",
    "Bitte gib deinem Reiseplan einen Namen.": "Дайте название своему плану поездки.",
    "Bitte gib deinen Namen ein.": "Введите своё имя.",
    "Bitte gib den Zeitraum deiner Reise an.": "Укажите даты поездки.",
    "Bitte gib eine gültige E-Mail-Adresse ein.": "Введите действительный адрес электронной почты.",
    "Bitte schreib zuerst eine Nachricht.": "Сначала напишите сообщение.",
    "Bitte überprüfe deine Eingaben.": "Проверьте введённые данные.",
    "Bitte versuche es später erneut.": "Пожалуйста, попробуйте позже.",
    "Böen": "Порывы",
    "Bootsverleih": "Прокат лодок",
    "Brauerei": "Пивоварня",
    "Bücherei": "Библиотека",
    "Burg & Schloss": "Замок и дворец",
    "ca. {duration}": "ок. {duration}",
    "Café": "Кафе",
    "Chat": "Чат",
    "Check-in / Check-out": "Заезд / отъезд",
    "Check-in und Check-out legen wir automatisch auf deinen ersten und letzten Tag.": "Заезд и отъезд мы автоматически ставим на первый и последний день.",
    "Check-out": "Отъезд",
    "Club": "Клуб",
    "da bist.": "что вы здесь.",
    "Dafür brauchst du ein Konto": "Для этого нужен аккаунт",
    "Dafür fehlt dir die Berechtigung. Melde dich neu an.": "У вас нет прав для этого. Войдите заново.",
    "Das dauert nur einen Augenblick.": "Это займёт всего мгновение.",
    "Das geht nicht mehr — du hast das Maximum erreicht.": "Это больше невозможно — достигнут максимум.",
    "Das hat nicht": "Это не",
    "Das Passwort braucht mindestens 8 Zeichen.": "Пароль должен содержать не менее 8 символов.",
    "Das Wetter ist gerade nicht verfügbar.": "Погода сейчас недоступна.",
    "Datenschutz": "Конфиденциальность",
    "Dauert unter einer Minute.": "Займёт меньше минуты.",
    "Dein Aufenthalt": "Ваше пребывание",
    "Dein digitaler Begleiter für den Aufenthalt: alles zu deinem Haus und deiner Region an einem Ort.": "Ваш цифровой спутник на время пребывания: всё о доме и регионе в одном месте.",
    "Dein Gastgeber": "Ваш хозяин",
    "Dein Gastgeber hat hier noch keine Informationen hinterlegt. Schau später noch einmal vorbei — oder frag einfach direkt nach.": "Ваш хозяин ещё не разместил здесь информацию. Загляните позже — или просто спросите напрямую.",
    "Dein Gastgeber, {name}": "Ваш хозяин, {name}",
    "Dein Planer": "Ваш планер",
    "Deine E-Mail-Adresse ist bestätigt.": "Ваш адрес электронной почты подтверждён.",
    "Deine Gastgeber": "Ваши хозяева",
    "Deine Gastgeber haben hier noch nichts empfohlen.": "Ваши хозяева пока ничего здесь не порекомендовали.",
    "Deine Region,": "Ваш регион,",
    "Deine Reisepläne konnten nicht geladen werden. Versuch es später noch einmal.": "Не удалось загрузить ваши планы поездок. Попробуйте позже.",
    "deinem Gastgeber": "вашего хозяина",
    "deiner Gastgeber": "от ваших хозяев",
    "Denkmal": "Памятник",
    "Der Chat": "Чат",
    "Der Chat konnte nicht geladen werden. Zieh nach unten oder versuch es später noch einmal.": "Не удалось загрузить чат. Потяните вниз или попробуйте позже.",
    "Der Eintrag konnte nicht entfernt werden.": "Не удалось удалить запись.",
    "Der Eintrag konnte nicht hinzugefügt werden.": "Не удалось добавить запись.",
    "Der Eintrag konnte nicht verschoben werden.": "Не удалось переместить запись.",
    "Der Reiseplan konnte nicht erstellt werden.": "Не удалось создать план поездки.",
    "Der Reiseplan konnte nicht gelöscht werden.": "Не удалось удалить план поездки.",
    "Der Reiseplan konnte nicht geöffnet werden.": "Не удалось открыть план поездки.",
    "Der Reiseplan konnte nicht gespeichert werden.": "Не удалось сохранить план поездки.",
    "Details": "Подробнее",
    "Die Abreise kann nicht vor der Anreise liegen.": "Отъезд не может быть раньше заезда.",
    "Die Empfehlungen konnten nicht geladen werden.": "Не удалось загрузить рекомендации.",
    "Die Empfehlungen konnten nicht geladen werden. Bitte versuche es später noch einmal.": "Не удалось загрузить рекомендации. Пожалуйста, попробуйте позже.",
    "Die Karte konnte nicht geladen werden.": "Не удалось загрузить карту.",
    "Die Nachricht konnte nicht gesendet werden.": "Не удалось отправить сообщение.",
    "Die Registrierung hat nicht geklappt. Bitte versuche es später erneut.": "Регистрация не удалась. Пожалуйста, попробуйте позже.",
    "Die Reihenfolge konnte nicht gespeichert werden.": "Не удалось сохранить порядок.",
    "Die Veranstaltungen konnten gerade nicht geladen werden. Bitte versuche es später noch einmal.": "Сейчас не удалось загрузить события. Пожалуйста, попробуйте позже.",
    "Diese Funktion ist bald verfügbar.": "Эта функция скоро появится.",
    "Diese Nachricht ist zu lang.": "Это сообщение слишком длинное.",
    "Diese Unterkunft ist noch nicht freigeschaltet — Empfehlungen aus der Region erscheinen hier, sobald sie es ist.": "Это жильё ещё не активировано — рекомендации по региону появятся здесь, как только это произойдёт.",
    "Dieser Bereich": "Этот раздел",
    "Dieser Chat ist nicht mehr verfügbar.": "Этот чат больше недоступен.",
    "Dieser Eintrag ist nicht mehr verfügbar.": "Эта запись больше недоступна.",
    "Dieser Link ist unvollständig.": "Эта ссылка неполная.",
    "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig. Versuche dich anzumelden — dein Konto ist möglicherweise schon aktiv.": "Эта ссылка уже использована или больше недействительна. Попробуйте войти — возможно, ваш аккаунт уже активен.",
    "Direkt verbunden": "Прямая связь",
    "Download": "Загрузка",
    "Du kannst dich jetzt anmelden und deine Gästemappe nutzen.": "Теперь вы можете войти и пользоваться гостевой папкой.",
    "E-Mail": "Эл. почта",
    "E-Mail bestätigen": "Подтвердите почту",
    "E-Mail noch nicht bestätigt": "Почта ещё не подтверждена",
    "Ein Reiseplan kann höchstens 60 Tage umfassen.": "План поездки может охватывать не более 60 дней.",
    "Einen Moment …": "Одну минуту …",
    "Einstellungen": "Настройки",
    "Eintritt auf Spendenbasis": "Вход за пожертвование",
    "Eintritt frei": "Вход свободный",
    "Eisdiele": "Кафе-мороженое",
    "Empfehlungen": "Рекомендации",
    "Empfehlungen für deinen Zeitraum": "Рекомендации на ваши даты",
    "Empfehlungen für dich": "Рекомендации для вас",
    "Endgültig löschen": "Удалить окончательно",
    "Entdecken": "Обзор",
    "entdeckt.": "как на ладони.",
    "Entfernen": "Удалить",
    "Erstmal ohne Konto ansehen": "Сначала осмотреться без аккаунта",
    "Events": "События",
    "Events & Erlebnisse": "События и впечатления",
    "Fast geschafft": "Почти готово",
    "Favoriten sammeln": "Собрать избранное",
    "Findet draußen statt": "Проходит на улице",
    "Fragen zum Check-in, ein Tipp für heute Abend oder eine Bitte — {name} antwortet dir hier direkt.": "Вопросы о заезде, совет на вечер или просьба — {name} ответит вам прямо здесь.",
    "frei nutzbar": "бесплатно",
    "Frühling": "Весна",
    "Führung": "Экскурсия",
    "Für den Chat brauchst du ein bestätigtes Konto.": "Для чата нужен подтверждённый аккаунт.",
    "Für die nächsten Stunden liegt keine Vorhersage vor.": "Прогноза на ближайшие часы нет.",
    "Für die nächsten Tage sind noch keine Veranstaltungen eingetragen. Frag gern deinen Gastgeber — oft gibt es kurzfristige Tipps.": "На ближайшие дни события не заявлены. Спросите хозяина — часто бывают советы в последний момент.",
    "Für diese E-Mail-Adresse gibt es schon ein Konto. Bitte melde dich stattdessen an.": "Для этого адреса уже есть аккаунт. Пожалуйста, войдите.",
    "Für diese Kategorie gibt es hier noch keine Einträge.": "В этой категории пока нет записей.",
    "Für diese Unterkunft ist der Planer nicht verfügbar.": "Для этого жилья планер недоступен.",
    "Für diese Unterkunft ist keine Kartenquelle hinterlegt.": "Для этого жилья не настроен источник карты.",
    "Für Familien geeignet": "Подходит для семей",
    "Für Hausgäste": "Для гостей дома",
    "Galerie": "Галерея",
    "ganztägig": "весь день",
    "Gast": "Гость",
    "Gästemappe": "Гостевая папка",
    "Gastgeber": "Хозяин",
    "Gastgeber fragen": "Спросить хозяина",
    "Gastronomie": "Еда и напитки",
    "Gehört zu deinem Aufenthalt": "Относится к вашему пребыванию",
    "geklappt": "получилось",
    "Gelesen": "Прочитано",
    "Geotop": "Геологический памятник",
    "Geschäft": "Магазин",
    "geschlossen": "закрыто",
    "Gesichtsbehandlung Natur": "Уход за лицом на натуральной основе",
    "Gestern": "Вчера",
    "Gib deinem Reiseplan einen Namen und verrate uns den Zeitraum deines Aufenthalts. Danach sammelst du überall in der App Favoriten mit „Zum Planer hinzufügen“ und verteilst sie auf deine Tage.": "Дайте название плану поездки и укажите даты пребывания. Дальше собирайте избранное по всему приложению кнопкой «Добавить в планер» и распределяйте по дням.",
    "GPX-Track laden": "Скачать GPX-трек",
    "Gut zu wissen": "Полезно знать",
    "Habt ihr einen Tipp für heute Abend?": "Есть совет на сегодняшний вечер?",
    "Hallo {name},": "Здравствуйте, {name},",
    "Häufige Fragen": "Частые вопросы",
    "Hauptnavigation": "Основная навигация",
    "Heiter": "Малооблачно",
    "Herbst": "Осень",
    "Herzlich willkommen —": "Добро пожаловать —",
    "Heute": "Сегодня",
    "Heute {hours}": "Сегодня {hours}",
    "Heute geschlossen": "Сегодня закрыто",
    "Heute im Detail": "Сегодня подробно",
    "Hin und zurück": "Туда и обратно",
    "Hinzufügen": "Добавить",
    "Historische Stätte": "Историческое место",
    "Historischer Kern": "Исторический центр",
    "Hofladen": "Фермерский магазин",
    "Höhle": "Пещера",
    "Home": "Главная",
    "Hunde erlaubt": "Можно с собакой",
    "Ich akzeptiere die": "Я принимаю",
    "Im Freien": "На открытом воздухе",
    "Impressum": "Выходные данные",
    "In der Region": "В регионе",
    "In dieser Auswahl steht gerade nichts an.": "В этой выборке сейчас ничего нет.",
    "inkl.": "включено",
    "Jetzt": "Сейчас",
    "Kanutour": "Байдарочный маршрут",
    "Karte": "Карта",
    "Kein Download nötig — die App lebt in deinem Browser.": "Ничего скачивать не нужно — приложение живёт в браузере.",
    "Kein Konto mit dieser E-Mail-Adresse gefunden.": "Аккаунт с таким адресом не найден.",
    "Kinderwagentauglich": "Подходит для коляски",
    "Kino": "Кинотеатр",
    "Kirche": "Церковь",
    "Klar": "Ясно",
    "Klassische Rückenmassage": "Классический массаж спины",
    "Klettertour": "Скалолазный маршрут",
    "Kloster": "Монастырь",
    "Können wir später einchecken?": "Можно заехать позже?",
    "Konto": "Аккаунт",
    "Konto erstellen": "Создать аккаунт",
    "Kräuterstempel-Massage": "Массаж травяными мешочками",
    "Langlaufloipe": "Лыжня",
    "Laufstrecke": "Беговой маршрут",
    "Leicht": "Легко",
    "Leichte Schauer": "Небольшие ливни",
    "Leichte Schneeregenschauer": "Небольшие ливни мокрого снега",
    "Leichte Schneeschauer": "Небольшие снежные заряды",
    "Leichter Regen": "Небольшой дождь",
    "Leichter Schneefall": "Небольшой снег",
    "Leichter Schneeregen": "Небольшой мокрый снег",
    "Letzter Schritt": "Последний шаг",
    "Link ungültig": "Ссылка недействительна",
    "Liste": "Список",
    "Los geht's": "Поехали",
    "Löschen": "Удалить",
    "Luftdruck": "Давление",
    "Luftfeuchte": "Влажность",
    "Mehr": "Ещё",
    "Mehr erfahren": "Подробнее",
    "Mein Planer": "Мой планер",
    "Mein Reiseplan": "Мой план поездки",
    "Meine Buchungen": "Мои бронирования",
    "Meine Reise · {house}": "Моя поездка · {house}",
    "Menü": "Меню",
    "Menü öffnen": "Открыть меню",
    "Menü schließen": "Закрыть меню",
    "Merken": "В избранное",
    "Mindestens 8 Zeichen": "Не менее 8 символов",
    "Mittel": "Средне",
    "Morgen": "Завтра",
    "Mountainbike": "Маунтинбайк",
    "Mühle": "Мельница",
    "Museum": "Музей",
    "N": "С",
    "Nach oben": "Вверх",
    "Nach unten": "Вниз",
    "Nachname": "Фамилия",
    "Nachricht schreiben …": "Написать сообщение …",
    "Nächstes Bild": "Следующее изображение",
    "Name deines Reiseplans": "Название плана поездки",
    "Name und Zeitraum deiner Reise.": "Название и даты вашей поездки.",
    "Natur": "Природа",
    "Naturinformation": "Информация о природе",
    "Nebel": "Туман",
    "Neuen Link anfordern": "Запросить новую ссылку",
    "Neuen Reiseplan anlegen": "Создать новый план поездки",
    "Nicht mehr verfügbar": "Больше недоступно",
    "Nichts angekommen? Sieh auch im Spam-Ordner nach.": "Ничего не пришло? Проверьте и папку «Спам».",
    "Nichts angekommen? Sieh im Spam-Ordner nach — die Nachricht kann einen Moment brauchen.": "Ничего не пришло? Загляните в папку «Спам» — письмо может идти некоторое время.",
    "Niederschlag": "Осадки",
    "NNO": "ССВ",
    "NNW": "ССЗ",
    "NO": "СВ",
    "Noch kein Konto?": "Ещё нет аккаунта?",
    "Noch kein Reiseplan": "Плана поездки пока нет",
    "Notfallkontakte": "Экстренные контакты",
    "Nur das Nötigste — in unter einer Minute fertig.": "Только самое необходимое — меньше минуты.",
    "NW": "СЗ",
    "O": "В",
    "oder": "или",
    "Öffne den Link in der E-Mail an {email}, dann ist dein Konto startklar.": "Откройте ссылку в письме на {email} — и аккаунт готов.",
    "Öffnungszeiten": "Часы работы",
    "ONO": "ВСВ",
    "Ort wird noch bekannt gegeben": "Место будет объявлено",
    "OSO": "ВЮВ",
    "Park & Garten": "Парк и сад",
    "Parkmöglichkeit": "Парковка",
    "Passwort": "Пароль",
    "Passwort anzeigen": "Показать пароль",
    "Passwort verbergen": "Скрыть пароль",
    "Passwort vergessen?": "Забыли пароль?",
    "Pilgerweg": "Паломнический путь",
    "Plane deine Reise — Tag für Tag.": "Планируйте поездку — день за днём.",
    "Planer": "Планер",
    "Radtour": "Велосипедный маршрут",
    "Regen": "Дождь",
    "Regenschauer": "Ливни",
    "Region": "Регион",
    "Region-Tipps": "Советы по региону",
    "Regionale Vorhersage für {place}.": "Прогноз по региону для {place}.",
    "Regionale Vorhersage.": "Прогноз по региону.",
    "Registrieren": "Зарегистрироваться",
    "Reiseplan angelegt.": "План поездки создан.",
    "Reiseplan anlegen": "Создать план поездки",
    "Reiseplan bearbeiten": "Изменить план поездки",
    "Reiseplan erstellen": "Создать план поездки",
    "Reiseplan gelöscht.": "План поездки удалён.",
    "Reiseplan gespeichert.": "План поездки сохранён.",
    "Reiseplan löschen": "Удалить план поездки",
    "Reiseplan löschen?": "Удалить план поездки?",
    "Reiseplan wählen": "Выбрать план поездки",
    "Reittour": "Конный маршрут",
    "Rennrad": "Шоссейный велосипед",
    "Reservierung erforderlich": "Требуется бронирование",
    "Restaurant": "Ресторан",
    "Restaurants": "Рестораны",
    "Restaurants, Sehenswürdigkeiten und Touren in deiner Nähe — als Liste oder auf der Karte.": "Рестораны, достопримечательности и маршруты рядом — списком или на карте.",
    "Route starten": "Построить маршрут",
    "Ruine": "Руины",
    "Rundweg": "Кольцевой маршрут",
    "S": "Ю",
    "Sächsische Schweiz": "Саксонская Швейцария",
    "Sammle alles, was dich interessiert, und ordne deine Tage so, wie es dir passt.": "Собирайте всё, что вам интересно, и распределяйте дни так, как удобно.",
    "Sauna & Pool": "Сауна и бассейн",
    "Schließen": "Закрыть",
    "Schneefall": "Снег",
    "Schneeregen": "Мокрый снег",
    "Schneeregenschauer": "Ливни мокрого снега",
    "Schneeschauer": "Снежные заряды",
    "Schneeschuhtour": "Маршрут на снегоступах",
    "Schnellzugriff": "Быстрый доступ",
    "schön dass du da bist.": "рады, что вы здесь.",
    "Schon registriert?": "Уже зарегистрированы?",
    "Schön, dass du": "Рады,",
    "schön, dass du da bist.": "рады, что вы здесь.",
    "Schreib deinen Gastgebern": "Напишите своим хозяевам",
    "Schreib deinen Gastgebern jederzeit — oder frag den Concierge, wenn es schnell gehen soll.": "Пишите хозяевам в любое время — или спросите консьержа, если нужно быстро.",
    "Schreib uns – wir antworten schnell.": "Напишите нам — мы быстро ответим.",
    "Schritt {step} von {total}": "Шаг {step} из {total}",
    "Schwer": "Сложно",
    "See": "Озеро",
    "Sehenswertes": "Интересное место",
    "Sehenswürdigkeit": "Достопримечательность",
    "Sehenswürdigkeiten": "Достопримечательности",
    "Sehr schwer": "Очень сложно",
    "Senden": "Отправить",
    "Services": "Услуги",
    "SO": "ЮВ",
    "So. 11:00 Uhr": "вс 11:00",
    "Sommer": "Лето",
    "Sonnig": "Солнечно",
    "Sonstiges": "Прочее",
    "Spa & Wellness": "Спа и велнес",
    "Spaziergang": "Прогулка",
    "Spielplatz": "Детская площадка",
    "Sport": "Спорт",
    "Sprache": "Язык",
    "SSO": "ЮЮВ",
    "SSW": "ЮЮЗ",
    "Stadtrundgang": "Прогулка по городу",
    "Starke Schauer": "Сильные ливни",
    "Starke Schneeregenschauer": "Сильные ливни мокрого снега",
    "Starke Schneeschauer": "Сильные снежные заряды",
    "Starker Regen": "Сильный дождь",
    "Starker Schneefall": "Сильный снег",
    "Starker Schneeregen": "Сильный мокрый снег",
    "Steht schon in deinem Planer.": "Уже есть в вашем планере.",
    "Streckentour": "Линейный маршрут",
    "Stündlich": "По часам",
    "SW": "ЮЗ",
    "Tag {n}": "День {n}",
    "Tagesplanung": "Планирование по дням",
    "Taupunkt": "Точка росы",
    "Teilen": "Поделиться",
    "Teilen nicht möglich.": "Поделиться не удалось.",
    "Teils bewölkt": "Переменная облачность",
    "Termin anfragen": "Запросить запись",
    "Termin buchen": "Записаться",
    "Termin folgt": "Дата будет объявлена",
    "Theater & Bühne": "Театр и сцена",
    "Ticket erforderlich": "Требуется билет",
    "Tickets": "Билеты",
    "Tipps & Events aus der Region erhalten": "Получать советы и события региона",
    "Tour": "Маршрут",
    "Touren": "Маршруты",
    "Tourist-Information": "Туристический центр",
    "Überspringen": "Пропустить",
    "UV-Index": "УФ-индекс",
    "Veranstaltung": "Событие",
    "Veranstaltungen": "События",
    "Veranstaltungen nicht verfügbar": "События недоступны",
    "Veranstaltungsort": "Площадка",
    "Vergangene Reise. Sie bleibt ein Jahr lang für dich gespeichert.": "Прошедшая поездка. Она сохранится для вас на год.",
    "Vergrößern": "Приблизить",
    "Verkehr": "Транспорт",
    "Verkleinern": "Отдалить",
    "Verschieben": "Переместить",
    "Verstanden": "Понятно",
    "Vom Haus": "От дома",
    "Vorheriges Bild": "Предыдущее изображение",
    "Vorhersage": "Прогноз",
    "Vorname": "Имя",
    "W": "З",
    "Wanderung": "Поход",
    "Wann gibt es Frühstück?": "Когда завтрак?",
    "Was dich erwartet": "Что вас ждёт",
    "Wasserfall": "Водопад",
    "WC": "Туалет",
    "Weinabend, Sonnenaufgangstour, Konzert im Fels — alles im Haus und in der Region, mit einem Tipp gebucht.": "Винный вечер, поход на рассвете, концерт среди скал — всё в доме и в регионе, в одно касание.",
    "Weingut": "Винодельня",
    "Weiter": "Далее",
    "Weitere Termine": "Другие даты",
    "Wellness & Sauna": "Велнес и сауна",
    "Wetter": "Погода",
    "Wetter nicht verfügbar": "Погода недоступна",
    "Wetter und Vorhersage": "Погода и прогноз",
    "Wetter wird geladen …": "Загрузка погоды …",
    "Wetterdaten:": "Данные о погоде:",
    "Willkommen": "Добро пожаловать",
    "Willkommen zurück": "С возвращением",
    "Wind": "Ветер",
    "Winter": "Зима",
    "Winterwanderung": "Зимний поход",
    "Wir haben dir eine Nachricht geschickt.": "Мы отправили вам письмо.",
    "Wir haben dir einen Bestätigungslink geschickt. Öffne ihn, damit dein Konto vollständig aktiv ist. Bis dahin kannst du die App schon nutzen.": "Мы отправили вам ссылку для подтверждения. Откройте её, чтобы аккаунт стал полностью активным. До этого приложением уже можно пользоваться.",
    "Wir konnten deinen Link nicht bestätigen.": "Не удалось подтвердить вашу ссылку.",
    "Wir melden uns mit einem Terminvorschlag.": "Мы свяжемся с вами и предложим время.",
    "Wir prüfen deinen Bestätigungslink.": "Мы проверяем вашу ссылку подтверждения.",
    "Wird geladen …": "Загрузка …",
    "WLAN, Frühstück, Check-out & mehr": "Wi-Fi, завтрак, отъезд и другое",
    "WNW": "ЗСЗ",
    "WSW": "ЗЮЗ",
    "z. B. Wochenende in der Sächsischen Schweiz": "напр. Выходные в Саксонской Швейцарии",
    "Zeitraum festlegen": "Указать даты",
    "Zieh eine Attraktion hierher.": "Перетащите сюда что-нибудь.",
    "Zimmerservice": "Обслуживание номеров",
    "Zoo & Tierpark": "Зоопарк",
    "Zu diesen Einträgen sind keine Koordinaten hinterlegt.": "Для этих записей нет координат.",
    "Zugang verweigert. Prüfe deine Zugangsdaten.": "Доступ запрещён. Проверьте данные для входа.",
    "Zum Planer hinzufügen": "Добавить в планер",
    "Zur Anmeldung": "К входу",
    "Zur Website": "На сайт",
    "Zurück": "Назад",
    "App zum Home-Bildschirm hinzufügen": "Добавить приложение на экран «Домой»",
    "Tippe auf „Teilen“ (Quadrat mit Pfeil nach oben — in Safari unten, in anderen Browsern oben) und wähle „Zum Home-Bildschirm“. Danach öffnest du die App direkt von dort — ohne Browserleiste.": "Нажмите «Поделиться» (квадрат со стрелкой вверх — в Safari внизу, в других браузерах вверху) и выберите «На экран „Домой“». После этого приложение открывается прямо оттуда — без панели браузера.",
    "Installieren": "Установить",
    "Neue Version der Gäste-App verfügbar.": "Доступна новая версия гостевого приложения.",
    "Aktualisieren": "Обновить",
    "Keine Verbindung — du siehst die zuletzt geladenen Inhalte.": "Нет соединения — вы видите последние загруженные данные.",
    "Link kopiert.": "Ссылка скопирована.",
    "App installieren": "Установить приложение",
    "Der Bildschirm kann gerade nicht angelassen werden.": "Сейчас нельзя оставить экран включённым.",
    "An": "Вкл.",
    "Aus": "Выкл.",
    "Bildschirm anlassen, solange du der Tour folgst": "Не выключать экран, пока вы идёте по маршруту",
    "Als App auf den Home-Bildschirm — auch offline nutzbar.": "Как приложение на экран «Домой» — работает и офлайн.",
    "Concierge": "Консьерж",
    "KI-Concierge · {house}": "ИИ-консьерж · {house}",
    "Das hat nicht geklappt. Bitte versuch es noch einmal.": "Не получилось. Попробуйте ещё раз.",
    "Direkt an {name} schreiben": "Написать {name} напрямую",
    "Concierge fragen": "Спросить консьержа",
    "Ohne Konto antwortet hier nur der Concierge. Um deinen Gastgebern direkt zu schreiben, brauchst du ein bestätigtes Konto.": "Без аккаунта здесь отвечает только консьерж. Чтобы написать хозяевам напрямую, нужен подтверждённый аккаунт.",
    "Soll ich das an {name} weitergeben?": "Передать это {name}?",
    "Ja, weitergeben": "Да, передать",
    "Nein, danke": "Нет, спасибо",
    "Der Concierge schreibt …": "Консьерж печатает …",
    "Frag den Concierge …": "Спросите консьержа …",
    "Der Concierge ist gerade nicht erreichbar. Mit einem bestätigten Konto kannst du deinen Gastgebern direkt schreiben.": "Консьерж сейчас недоступен. С подтверждённым аккаунтом вы можете написать хозяевам напрямую.",
    "Du schreibst jetzt direkt mit {name}. Die Antwort kommt hier.": "Теперь вы пишете напрямую {name}. Ответ придёт сюда.",
    "Der Concierge antwortet wieder. Deine Gastgeber lesen weiter mit.": "Снова отвечает консьерж. Хозяева продолжают читать переписку.",
    "Der Concierge ist gerade nicht verfügbar. Deine Nachricht ist bei {name} angekommen — die Antwort kommt hier.": "Консьерж сейчас недоступен. Ваше сообщение получил(а) {name} — ответ придёт сюда.",
    "Dein Name wurde gespeichert.": "Ваше имя сохранено.",
    "Dein Name konnte nicht gespeichert werden. Bitte versuche es später erneut.": "Не удалось сохранить имя. Пожалуйста, попробуйте позже.",
    "Bitte gib dein aktuelles Passwort ein.": "Пожалуйста, введите текущий пароль.",
    "Das neue Passwort muss sich vom aktuellen unterscheiden.": "Новый пароль должен отличаться от текущего.",
    "Die Passwörter stimmen nicht überein.": "Пароли не совпадают.",
    "Dein Passwort wurde geändert.": "Ваш пароль изменён.",
    "Das aktuelle Passwort stimmt nicht.": "Текущий пароль неверен.",
    "Das Passwort konnte nicht geändert werden. Bitte versuche es später erneut.": "Не удалось изменить пароль. Пожалуйста, попробуйте позже.",
    "Dein Konto": "Ваш аккаунт",
    "Du nutzt die App ohne Konto": "Вы пользуетесь приложением без аккаунта",
    "Mit einem Konto kannst du deinen Namen und dein Passwort hier verwalten.": "С аккаунтом вы сможете управлять здесь своим именем и паролем.",
    "Dein Name": "Ваше имя",
    "Name": "Имя",
    "Name speichern": "Сохранить имя",
    "Passwort ändern": "Изменить пароль",
    "Aktuelles Passwort": "Текущий пароль",
    "Neues Passwort": "Новый пароль",
    "Mindestens {count} Zeichen.": "Не менее {count} символов.",
    "Neues Passwort wiederholen": "Повторите новый пароль",
    "Hallo,": "Здравствуйте,",
    "Die App ist installiert": "Приложение установлено",
    "Du findest sie auf deinem Home-Bildschirm und öffnest sie von dort direkt — ohne Browserleiste.": "Оно находится на экране «Домой» — открывайте его прямо оттуда, без панели браузера.",
    "Zur Startseite": "На главную",
    "Direkt vom Home-Bildschirm starten": "Запуск прямо с экрана «Домой»",
    "Im Vollbild, ohne Browserleiste": "Во весь экран, без панели браузера",
    "Gästemappe auch ohne Internet": "Папка гостя даже без интернета",
    "Jetzt installieren": "Установить",
    "Dein Browser fragt noch einmal nach — bestätige dort mit „Installieren“.": "Браузер переспросит — подтвердите кнопкой «Установить».",
    "So geht’s in drei Schritten": "Как это сделать за три шага",
    "Tippe auf „Teilen“": "Нажмите «Поделиться»",
    "In Safari unten in der Leiste, in anderen Browsern oben rechts.": "В Safari — на панели внизу, в других браузерах — справа вверху.",
    "Wähle „Zum Home-Bildschirm“": "Выберите «На экран „Домой“»",
    "Falls du es nicht siehst, scrolle im Menü etwas nach unten.": "Если пункта не видно, прокрутите меню немного вниз.",
    "Tippe oben rechts auf „Hinzufügen“": "Нажмите «Добавить» справа вверху",
    "Fertig — die App liegt jetzt auf deinem Home-Bildschirm.": "Готово — приложение теперь на экране «Домой».",
    "Dieser Browser kann die App nicht installieren. Öffne die Seite in Chrome (Android) oder Safari (iPhone und iPad) und tippe dort auf „App installieren“.": "Этот браузер не может установить приложение. Откройте страницу в Chrome (Android) или Safari (iPhone и iPad) и нажмите там «Установить приложение».",
    "Die App ist installiert. Du findest sie jetzt auf deinem Home-Bildschirm.": "Приложение установлено. Теперь оно на экране «Домой».",
    "Der Link konnte nicht angefordert werden. Bitte versuche es später erneut.": "Не удалось запросить ссылку. Попробуйте позже.",
    "Wir schicken dir einen Link, mit dem du ein neues Passwort vergibst.": "Мы отправим вам ссылку, по которой можно задать новый пароль.",
    "Link anfordern": "Запросить ссылку",
    "Zurück zur Anmeldung": "Назад ко входу",
    "Schau in dein Postfach": "Проверьте почту",
    "Der Link ist 2 Stunden gültig.": "Ссылка действительна 2 часа.",
    "Falls zu {email} ein Konto existiert, haben wir dir einen Link zum Zurücksetzen geschickt.": "Если для {email} существует аккаунт, мы отправили вам ссылку для сброса пароля.",
    "Dieser Link ist abgelaufen. Bitte fordere einen neuen an.": "Срок действия ссылки истёк. Запросите новую.",
    "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig.": "Эта ссылка уже использована или больше не действительна.",
    "Passwort geändert": "Пароль изменён",
    "Dein neues Passwort ist gespeichert.": "Ваш новый пароль сохранён.",
    "Aus Sicherheitsgründen wurdest du auf allen Geräten abgemeldet. Melde dich mit deinem neuen Passwort an.": "В целях безопасности вы вышли из аккаунта на всех устройствах. Войдите с новым паролем.",
    "Neues Passwort vergeben": "Задать новый пароль",
    "Wähle ein neues Passwort für dein Konto.": "Выберите новый пароль для своего аккаунта.",
    "Passwort speichern": "Сохранить пароль",
    "Du bist bereits angemeldet. Dein Passwort änderst du in den Einstellungen.": "Вы уже вошли. Пароль можно изменить в настройках.",
    "Dieser Link ist abgelaufen. Fordere nach dem Anmelden einen neuen an — oder registriere dich mit derselben Adresse noch einmal.": "Срок действия ссылки истёк. Запросите новую после входа — или зарегистрируйтесь ещё раз с тем же адресом.",
    "Wir haben dir einen neuen Link an {email} geschickt.": "Мы отправили новую ссылку на {email}.",
    "Link erneut senden": "Отправить ссылку ещё раз",
    "Benachrichtigungen sind aktiviert.": "Уведомления включены.",
    "Benachrichtigungen konnten nicht geändert werden.": "Не удалось изменить уведомления.",
    "Auf dem iPhone kommen Benachrichtigungen nur in der installierten App an. Füge die App zuerst zum Home-Bildschirm hinzu.": "На iPhone уведомления приходят только в установленное приложение. Сначала добавьте приложение на экран «Домой».",
    "Benachrichtigungen sind für diese Seite blockiert. Du kannst sie in den Einstellungen deines Browsers wieder erlauben.": "Уведомления для этого сайта заблокированы. Их можно снова разрешить в настройках браузера.",
    "Erhalte Hinweise zu deinem Aufenthalt, Veranstaltungen und Neuigkeiten aus dem Haus.": "Получайте информацию о пребывании, мероприятиях и новостях дома.",
    "Du erhältst Benachrichtigungen von diesem Haus auf diesem Gerät.": "Вы получаете уведомления от этого дома на этом устройстве.",
    "Benachrichtigungen": "Уведомления",
    "Neuigkeiten vom Gastgeber erhalten": "Получать новости от хозяина",
    "Unterkunft": "Жильё",
    "Der Wechsel hat nicht geklappt. Bitte versuche es erneut.": "Не удалось переключиться. Попробуйте ещё раз.",
    "Deine Anmeldung konnte nicht übernommen werden. Bitte melde dich an.": "Не удалось перенести вход. Пожалуйста, войдите.",
    "Seite nicht gefunden": "Страница не найдена",
    "Diese Seite gibt es nicht": "Такой страницы нет",
    "Unter dieser Adresse ist keine Gäste-App zu finden. Vielleicht hat sich ein Tippfehler eingeschlichen — oder die Unterkunft ist noch nicht freigeschaltet.": "По этому адресу нет гостевого приложения. Возможно, в ссылке опечатка — или жильё ещё не активировано.",
    "Bitte prüfe den Link oder scanne den QR-Code deiner Unterkunft erneut.": "Проверьте ссылку или снова отсканируйте QR-код вашего жилья.",
    "Vorschau · Entwurf — für Gäste noch nicht sichtbar": "Предпросмотр · Черновик — гости пока не видят",
    "Läuft gerade": "Идёт сейчас",
    "Alle Veranstaltungen der Region.": "Все мероприятия региона.",
    "Veranstaltungen bis {km} km Entfernung.": "Мероприятия в радиусе {km} км.",
    "Nur in der Nähe anzeigen": "Показать только поблизости",
    "Auch weiter entfernte anzeigen": "Показать и более отдалённые",
    "Notruf": "Экстренный вызов",
    "Feuerwehr & Rettungsdienst": "Пожарные и скорая помощь",
    "Polizei": "Полиция",
    "Hat begonnen": "Уже началось",
    "Der Link ist veraltet oder unvollständig. Auf der Startseite findest du alles rund um deinen Aufenthalt.": "Ссылка устарела или неполная. На главной странице есть всё о вашем пребывании.",
    "Eingeplant für {day}": "Запланировано на {day}",
    "Gemerkt — noch ohne Tag.": "Сохранено — пока без дня.",
    "Findet am {day} statt": "Проходит {day}",
    "Termin: {day}": "Дата: {day}",
    "Tag wählen": "Выбрать день",
    "Noch ohne Tag": "Пока без дня",
    "Gemerkt, noch ohne Tag": "Сохранено, пока без дня",
    "Wähle für jeden Eintrag einen Tag oder zieh ihn am Symbol dorthin. Die Pfeile ändern die Reihenfolge innerhalb eines Tages. Veranstaltungen mit Termin stehen schon an ihrem Tag.": "Выберите день для каждой записи или перетащите её туда за значок. Стрелки меняют порядок внутри дня. Мероприятия с датой уже стоят в своём дне.",
    "Verschoben auf {day}": "Перенесено на {day}",
    "{day} um {time} Uhr": "{day} в {time}",
    "Termin steht fest": "Дата мероприятия фиксирована",
    "„{title}“ findet am {when} statt. Trotzdem auf {day} legen?": "«{title}» проходит {when}. Всё равно поставить на {day}?",
    "Trotzdem verschieben": "Всё равно перенести",
    "Infos zum Haus": "О доме",
    "Mein Apartment": "Мои апартаменты",
    "Service & Angebote": "Услуги и предложения",
    "Rund um den Aufenthalt": "Во время пребывания",
    "Anreise & Mobilität": "Как добраться и транспорт",
    "Sicherheit & Notfall": "Безопасность и экстренные случаи",
    "Konzerte & Musik": "Концерты и музыка",
    "Party & Nachtleben": "Вечеринки и ночная жизнь",
    "Feste & Festivals": "Праздники и фестивали",
    "Märkte": "Рынки и ярмарки",
    "Shows & Performances": "Шоу и выступления",
    "Comedy & Kabarett": "Комедия и кабаре",
    "Film & Kino": "Кино",
    "Ausstellungen & Kunst": "Выставки и искусство",
    "Lesungen & Literatur": "Чтения и литература",
    "Vorträge & Bildung": "Лекции и образование",
    "Führungen & Touren": "Экскурсии",
    "Sport & Bewegung": "Спорт и активность",
    "Kinder & Familie": "Дети и семья",
    "Essen & Trinken": "Еда и напитки",
    "Workshops & Kurse": "Мастер-классы и курсы",
    "Brauchtum & Tradition": "Обычаи и традиции",
    "Concierge von {house}": "Консьерж {house}",
    "Willkommen im {house}! Ich bin der digitale Concierge und beantworte deine Fragen rund um den Aufenthalt — jederzeit. Für alles andere leite ich dich gern an deine Gastgeber weiter.": "Добро пожаловать в {house}! Я цифровой консьерж и отвечу на ваши вопросы о пребывании — в любое время. Со всем остальным я с радостью свяжу вас с хозяевами.",
    "KI": "ИИ",
    "Check-in & Ankommen": "Заселение и приезд",
    "{address} in Google Maps öffnen": "Открыть {address} в Google Maps"
}
